<cache-date></cache-date>

<period></period>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
<br>



<div class="row">
	<div class="col-md-12">
		<chart [data]="chartData.data" [options]="chartData.options" [sextant]="'chart'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<hr><br>


<loading [isLoad]="totalLoader"></loading>
<div *ngIf="total && total.totalInfo && total.totalInfo.countReg && !totalLoader && filter.filterParams.isShowRegDayTotal">
	<div class="col-md-12">
		<div id="js-total-info" style="display: block;">
			<div class="table-responsive">
				<table class="table js-ul-total-regday-table" data-period="day">
					<thead>
						<tr>
							<th></th>
							<th>{{ 'adminstat.common.userCount' | translate }}</th>
							<th></th>
							<th>{{ 'adminstat.common.siteCount' | translate }}</th>
							<th>{{ 'adminstat.users.reg_day.sitesPublishedCount' | translate }}</th>
							<th>{{ 'adminstat.users.reg_day.domainsCount' | translate }}</th>
						</tr>
					</thead>
					
					<tbody>
						<tr>
							<td>{{ 'adminstat.common.All count' | translate }}</td>
							<td></td>
							<td class="js-ul-regday-total-countreg" data-period="day">{{total.totalInfo.countReg}}</td>
							<td>{{total.totalInfo.sitesCount}}</td>
							<td>{{total.totalInfo.sitesPublished}}</td>
							<td>{{total.totalInfo.sitesPublishedWithDomain}}</td>
						</tr>
						<tr>
							<td>{{ 'adminstat.common.In query count' | translate }}</td>
							<td></td>
							<td>{{total.inQuery.countReg}}</td>
							<td>{{total.inQuery.sitesCount}}</td>
							<td>{{total.inQuery.sitesPublished}}</td>
							<td>{{total.inQuery.sitesPublishedWithDomain}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<hr>
</div>


<br>
<loading [isLoad]="paginationLoader"></loading>
<ngb-pagination
	[extlinks]="links"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1"
	[(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
	*ngIf="!paginationLoader && pagination.pageCount > 1"
></ngb-pagination>


<br>
<div class="col-md-12">
	<span class="button-download-link" (click)="downloadButton()">
		<i class="fa fa-download" aria-hidden="true"></i>
		{{ 'adminstat.users.reg_day.users with social' | translate }}
	</span>
</div>
<br>


<ref_status [stats]="stats"></ref_status>


<loading [isLoad]="statsLoader"></loading>
<table *ngIf="!statsLoader && stats && stats.length > 0" class="table table-bordered" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
		<tr>
			<th>{{ 'adminstat.common.Date' | translate }}</th>
			<th>{{ 'adminstat.common.Total info' | translate }}</th>
		</tr>
	</thead>
	
	<tbody>
		<tr *ngFor="let stat of stats">
			<td [class]="stat.day == 0 || stat.day == 6 ? 'table-info' : ''">
				{{ stat.currentPeriod }}
			</td>
			
			<td>
				<div class="row">
					<div class="col-md-12">
						<table class="table">
							<tbody>
								<tr>
									<td>
										{{ 'adminstat.users.reg_day.countReg' | translate }}
									</td>
									
									<td class="ul-reg-day-ref-with-users">
										{{ stat?.total?.countReg }}
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.users.reg_day.usersWithSite' | translate }}
									</td>
									
									<td>
										<span class="ul-reg-day-ref-with-site">
											{{ stat?.total?.usersWithSite }} ({{ helper.percentageFormat(stat?.total?.usersWithSite / stat?.total?.countReg) }})
										</span>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.common.sites_created_by_period' | translate }}
										
									</td>
									
									<td>
										<span class="ul-reg-day-ref-sites">
											{{ stat?.total?.createdSites }} ({{ helper.percentageFormat(stat?.total?.createdSites / stat?.total?.usersWithSite) }})
										</span>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.users.reg_day.publishedSites' | translate }}
									</td>
									
									<td>
										<span class="ul-reg-day-ref-published-site">
											{{ stat?.total?.publishedSites }} ({{ helper.percentageFormat(stat?.total?.publishedSites / stat?.total?.countReg) }})
										</span>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.users.reg_day.uncomplitedSites' | translate }}
									</td>
									
									<td>
										{{ stat?.total?.uncomplitedSites }} ({{ helper.percentageFormat(stat?.total?.uncomplitedSites / stat?.total?.countReg) }})
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.users.reg_day.published' | translate }}
									</td>
									
									<td>
										{{ stat?.total?.published }}
									</td>
								</tr>

								<ng-container *ngIf="lpTracker">
									<tr *ngFor="let type of ['active', 'fallen']">
										<td>
											<b>{{ 'adminstat.users.reg_day.' + type + 'Sites' | translate }}</b>
										</td>
										
										<td>
											<loading [isLoad]="lpTrackerData[type].loader"></loading>
											{{ lpTrackerData[type].count }}
											<button-anhor *ngIf="!lpTrackerData[type].loader" (click)="getLpTrackerData(stat, type)">
												{{ 'adminstat.support.report.get' | translate }}
											</button-anhor>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				
					<div class="col-md-12">
						<ngb-accordion
							#acc="ngbAccordion"
							(click)="showSubjectList(stat)"
						>
							<ngb-panel
								title="{{ 'adminstat.users.reg_day.subjects' | translate }}"
							>
								<ng-template ngbPanelContent>
									<loading
										[isLoad]="subjectsLoaderMap[stat.currentPeriod]"
									></loading>
									
									<table class="table">
										<thead>
											<th>
												{{ 'adminstat.users.reg_day.subjects' | translate }}
											</th>
											
											<th>
												{{ 'adminstat.common.All count' | translate }} ?
											</th>
											
											<th>
												{{ 'adminstat.users.reg_day.on air' | translate }} ?
											</th>
										</thead>
										
										<tbody>
											<tr *ngFor="let s of stat.subject">
												<td>
													{{ s.subjectId }}
												</td>
												
												<td>
													{{ s.count }} (?%)
												</td>
												
												<td>
													{{ s.countPublished }} (?%)
												</td>
											</tr>
										</tbody>
									</table>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
						
						<refs
							[stats]="stat"
							[filterParams]="filter.filterParams"
							[currentUrl]="filter.currentUrl"
						></refs>
					</div>
				</div>
			</td>
		</tr>
	</tbody>
</table>
